import * as Blob$SolvuuApi0 from "solvuu-api0/./blob.bs.js";
import * as Blob_bs$SolvuuApi0 from "solvuu-api0/./blob_bs.bs.js";
import * as Blob_event_bs$SolvuuApi0 from "solvuu-api0/./blob_event_bs.bs.js";
import * as Blob_event_atd$SolvuuApi0 from "solvuu-api0/./blob_event_atd.bs.js";
import * as Blob_events_bs$SolvuuApi0 from "solvuu-api0/./blob_events_bs.bs.js";
import * as Blob_events_atd$SolvuuApi0 from "solvuu-api0/./blob_events_atd.bs.js";
import * as Blob_create_request_bs$SolvuuApi0 from "solvuu-api0/./blob_create_request_bs.bs.js";
import * as Blob_create_response_bs$SolvuuApi0 from "solvuu-api0/./blob_create_response_bs.bs.js";
import * as Blob_create_response_atd$SolvuuApi0 from "solvuu-api0/./blob_create_response_atd.bs.js";
import * as Blob_get_by_id_request_bs$SolvuuApi0 from "solvuu-api0/./blob_get_by_id_request_bs.bs.js";
import * as Blob_get_by_id_response_bs$SolvuuApi0 from "solvuu-api0/./blob_get_by_id_response_bs.bs.js";
import * as Blob_get_events_request_bs$SolvuuApi0 from "solvuu-api0/./blob_get_events_request_bs.bs.js";
import * as Blob_get_by_id_response_atd$SolvuuApi0 from "solvuu-api0/./blob_get_by_id_response_atd.bs.js";
import * as Blob_get_events_response_bs$SolvuuApi0 from "solvuu-api0/./blob_get_events_response_bs.bs.js";
import * as Blob_get_events_response_atd$SolvuuApi0 from "solvuu-api0/./blob_get_events_response_atd.bs.js";
var Json = Blob_bs$SolvuuApi0;
var json_of_int64 = Blob$SolvuuApi0.json_of_int64;
var json_of_id = Blob$SolvuuApi0.json_of_id;
var json_of_event_id = Blob$SolvuuApi0.json_of_event_id;
var json_of_s3_instructions = Blob$SolvuuApi0.json_of_s3_instructions;
var json_of_s3_download = Blob$SolvuuApi0.json_of_s3_download;
var json_of_s3_upload = Blob$SolvuuApi0.json_of_s3_upload;
var json_of_instructions = Blob$SolvuuApi0.json_of_instructions;
var json_of_denied_reason = Blob$SolvuuApi0.json_of_denied_reason;
var json_of_processor_job = Blob$SolvuuApi0.json_of_processor_job;
var json_of_storage = Blob$SolvuuApi0.json_of_storage;
var json_of_checksum = Blob$SolvuuApi0.json_of_checksum;
var json_of_created = Blob$SolvuuApi0.json_of_created;
var json_of_started = Blob$SolvuuApi0.json_of_started;
var json_of_available = Blob$SolvuuApi0.json_of_available;
var json_of_validated = Blob$SolvuuApi0.json_of_validated;
var json_of_completed = Blob$SolvuuApi0.json_of_completed;
var json_of_corrupt = Blob$SolvuuApi0.json_of_corrupt;
var json_of_failed = Blob$SolvuuApi0.json_of_failed;
var json_of_state = Blob$SolvuuApi0.json_of_state;
var json_of_t = Blob$SolvuuApi0.json_of_t;
var int64_of_json = Blob$SolvuuApi0.int64_of_json;
var id_of_json = Blob$SolvuuApi0.id_of_json;
var event_id_of_json = Blob$SolvuuApi0.event_id_of_json;
var s3_instructions_of_json = Blob$SolvuuApi0.s3_instructions_of_json;
var s3_download_of_json = Blob$SolvuuApi0.s3_download_of_json;
var s3_upload_of_json = Blob$SolvuuApi0.s3_upload_of_json;
var instructions_of_json = Blob$SolvuuApi0.instructions_of_json;
var denied_reason_of_json = Blob$SolvuuApi0.denied_reason_of_json;
var processor_job_of_json = Blob$SolvuuApi0.processor_job_of_json;
var storage_of_json = Blob$SolvuuApi0.storage_of_json;
var checksum_of_json = Blob$SolvuuApi0.checksum_of_json;
var created_of_json = Blob$SolvuuApi0.created_of_json;
var started_of_json = Blob$SolvuuApi0.started_of_json;
var available_of_json = Blob$SolvuuApi0.available_of_json;
var validated_of_json = Blob$SolvuuApi0.validated_of_json;
var completed_of_json = Blob$SolvuuApi0.completed_of_json;
var corrupt_of_json = Blob$SolvuuApi0.corrupt_of_json;
var failed_of_json = Blob$SolvuuApi0.failed_of_json;
var state_of_json = Blob$SolvuuApi0.state_of_json;
var t_of_json = Blob$SolvuuApi0.t_of_json;
var $$Event = {
  Json: Blob_event_bs$SolvuuApi0,
  json_of_event: Blob_event_atd$SolvuuApi0.json_of_event,
  json_of_id: Blob_event_atd$SolvuuApi0.json_of_id,
  json_of_job_id: Blob_event_atd$SolvuuApi0.json_of_job_id,
  json_of_int64: Blob_event_atd$SolvuuApi0.json_of_int64,
  json_of_checksum: Blob_event_atd$SolvuuApi0.json_of_checksum,
  json_of_s3_location: Blob_event_atd$SolvuuApi0.json_of_s3_location,
  json_of_storage: Blob_event_atd$SolvuuApi0.json_of_storage,
  json_of_processor_job: Blob_event_atd$SolvuuApi0.json_of_processor_job,
  json_of_create_upload: Blob_event_atd$SolvuuApi0.json_of_create_upload,
  json_of_create: Blob_event_atd$SolvuuApi0.json_of_create,
  json_of_s3_progress_part: Blob_event_atd$SolvuuApi0.json_of_s3_progress_part,
  json_of_s3_progress_report: Blob_event_atd$SolvuuApi0.json_of_s3_progress_report,
  json_of_s3_progress: Blob_event_atd$SolvuuApi0.json_of_s3_progress,
  json_of_progress: Blob_event_atd$SolvuuApi0.json_of_progress,
  json_of_info: Blob_event_atd$SolvuuApi0.json_of_info,
  json_of_t: Blob_event_atd$SolvuuApi0.json_of_t,
  event_of_json: Blob_event_atd$SolvuuApi0.event_of_json,
  id_of_json: Blob_event_atd$SolvuuApi0.id_of_json,
  job_id_of_json: Blob_event_atd$SolvuuApi0.job_id_of_json,
  int64_of_json: Blob_event_atd$SolvuuApi0.int64_of_json,
  checksum_of_json: Blob_event_atd$SolvuuApi0.checksum_of_json,
  s3_location_of_json: Blob_event_atd$SolvuuApi0.s3_location_of_json,
  storage_of_json: Blob_event_atd$SolvuuApi0.storage_of_json,
  processor_job_of_json: Blob_event_atd$SolvuuApi0.processor_job_of_json,
  create_upload_of_json: Blob_event_atd$SolvuuApi0.create_upload_of_json,
  create_of_json: Blob_event_atd$SolvuuApi0.create_of_json,
  s3_progress_part_of_json: Blob_event_atd$SolvuuApi0.s3_progress_part_of_json,
  s3_progress_report_of_json: Blob_event_atd$SolvuuApi0.s3_progress_report_of_json,
  s3_progress_of_json: Blob_event_atd$SolvuuApi0.s3_progress_of_json,
  progress_of_json: Blob_event_atd$SolvuuApi0.progress_of_json,
  info_of_json: Blob_event_atd$SolvuuApi0.info_of_json,
  t_of_json: Blob_event_atd$SolvuuApi0.t_of_json
};
var Events = {
  Json: Blob_events_bs$SolvuuApi0,
  json_of_event: Blob_events_atd$SolvuuApi0.json_of_event,
  json_of_t: Blob_events_atd$SolvuuApi0.json_of_t,
  event_of_json: Blob_events_atd$SolvuuApi0.event_of_json,
  t_of_json: Blob_events_atd$SolvuuApi0.t_of_json
};
var source = Blob$SolvuuApi0.source;
var entity = Blob$SolvuuApi0.entity;
var $$let = Blob$SolvuuApi0.Get_by_id.$$Request;
var Get_by_id_entity = Blob$SolvuuApi0.Get_by_id.entity;
var Get_by_id_service = Blob$SolvuuApi0.Get_by_id.service;
var Get_by_id_Request = {
  Json: Blob_get_by_id_request_bs$SolvuuApi0,
  json_of_id: $$let.json_of_id,
  json_of_info: $$let.json_of_info,
  id_of_json: $$let.id_of_json,
  info_of_json: $$let.info_of_json,
  path: $$let.path,
  body: $$let.body,
  info: $$let.info
};
var Get_by_id_Response = {
  Json: Blob_get_by_id_response_bs$SolvuuApi0,
  json_of_blob: Blob_get_by_id_response_atd$SolvuuApi0.json_of_blob,
  json_of_denied_reason: Blob_get_by_id_response_atd$SolvuuApi0.json_of_denied_reason,
  json_of_instructions: Blob_get_by_id_response_atd$SolvuuApi0.json_of_instructions,
  json_of_instructions_response: Blob_get_by_id_response_atd$SolvuuApi0.json_of_instructions_response,
  json_of_ok: Blob_get_by_id_response_atd$SolvuuApi0.json_of_ok,
  json_of_bad_request: Blob_get_by_id_response_atd$SolvuuApi0.json_of_bad_request,
  json_of_not_found: Blob_get_by_id_response_atd$SolvuuApi0.json_of_not_found,
  blob_of_json: Blob_get_by_id_response_atd$SolvuuApi0.blob_of_json,
  denied_reason_of_json: Blob_get_by_id_response_atd$SolvuuApi0.denied_reason_of_json,
  instructions_of_json: Blob_get_by_id_response_atd$SolvuuApi0.instructions_of_json,
  instructions_response_of_json: Blob_get_by_id_response_atd$SolvuuApi0.instructions_response_of_json,
  ok_of_json: Blob_get_by_id_response_atd$SolvuuApi0.ok_of_json,
  bad_request_of_json: Blob_get_by_id_response_atd$SolvuuApi0.bad_request_of_json,
  not_found_of_json: Blob_get_by_id_response_atd$SolvuuApi0.not_found_of_json
};
var Get_by_id = {
  entity: Get_by_id_entity,
  service: Get_by_id_service,
  $$Request: Get_by_id_Request,
  $$Response: Get_by_id_Response
};
var Get_all = Blob$SolvuuApi0.Get_all;
var $$let$1 = Blob$SolvuuApi0.Create.$$Request;
var Create_entity = Blob$SolvuuApi0.Create.entity;
var Create_service = Blob$SolvuuApi0.Create.service;
var Create_Request = {
  Json: Blob_create_request_bs$SolvuuApi0,
  json_of_int64: $$let$1.json_of_int64,
  json_of_checksum: $$let$1.json_of_checksum,
  json_of_info: $$let$1.json_of_info,
  int64_of_json: $$let$1.int64_of_json,
  checksum_of_json: $$let$1.checksum_of_json,
  info_of_json: $$let$1.info_of_json,
  path: $$let$1.path,
  body: $$let$1.body,
  info: $$let$1.info
};
var Create_Response = {
  Json: Blob_create_response_bs$SolvuuApi0,
  json_of_ok: Blob_create_response_atd$SolvuuApi0.json_of_ok,
  json_of_bad_request: Blob_create_response_atd$SolvuuApi0.json_of_bad_request,
  json_of_not_found: Blob_create_response_atd$SolvuuApi0.json_of_not_found,
  ok_of_json: Blob_create_response_atd$SolvuuApi0.ok_of_json,
  bad_request_of_json: Blob_create_response_atd$SolvuuApi0.bad_request_of_json,
  not_found_of_json: Blob_create_response_atd$SolvuuApi0.not_found_of_json
};
var Create = {
  entity: Create_entity,
  service: Create_service,
  $$Request: Create_Request,
  $$Response: Create_Response
};
var $$let$2 = Blob$SolvuuApi0.Get_events.$$Request;
var Get_events_entity = Blob$SolvuuApi0.Get_events.entity;
var Get_events_service = Blob$SolvuuApi0.Get_events.service;
var Get_events_Request = {
  Json: Blob_get_events_request_bs$SolvuuApi0,
  json_of_info: $$let$2.json_of_info,
  info_of_json: $$let$2.info_of_json,
  path: $$let$2.path,
  body: $$let$2.body,
  info: $$let$2.info
};
var Get_events_Response = {
  Json: Blob_get_events_response_bs$SolvuuApi0,
  json_of_ok: Blob_get_events_response_atd$SolvuuApi0.json_of_ok,
  json_of_bad_request: Blob_get_events_response_atd$SolvuuApi0.json_of_bad_request,
  json_of_not_found: Blob_get_events_response_atd$SolvuuApi0.json_of_not_found,
  ok_of_json: Blob_get_events_response_atd$SolvuuApi0.ok_of_json,
  bad_request_of_json: Blob_get_events_response_atd$SolvuuApi0.bad_request_of_json,
  not_found_of_json: Blob_get_events_response_atd$SolvuuApi0.not_found_of_json
};
var Get_events = {
  entity: Get_events_entity,
  service: Get_events_service,
  $$Request: Get_events_Request,
  $$Response: Get_events_Response
};
export { Json, json_of_int64, json_of_id, json_of_event_id, json_of_s3_instructions, json_of_s3_download, json_of_s3_upload, json_of_instructions, json_of_denied_reason, json_of_processor_job, json_of_storage, json_of_checksum, json_of_created, json_of_started, json_of_available, json_of_validated, json_of_completed, json_of_corrupt, json_of_failed, json_of_state, json_of_t, int64_of_json, id_of_json, event_id_of_json, s3_instructions_of_json, s3_download_of_json, s3_upload_of_json, instructions_of_json, denied_reason_of_json, processor_job_of_json, storage_of_json, checksum_of_json, created_of_json, started_of_json, available_of_json, validated_of_json, completed_of_json, corrupt_of_json, failed_of_json, state_of_json, t_of_json, $$Event, Events, source, entity, Get_by_id, Get_all, Create, Get_events };
/* Blob-SolvuuApi0 Not a pure module */